<div class="step-content">

  <div class="step-header">
    <h2>
      {{ isEditMode ? 'Edit' : 'Add' }} work/education history
    </h2>
    <div class="step-description-row">
      <p class="step-description">Enter up to 5 years of history including gaps in work/school.</p>
      <label class="checkbox-option">
        <app-checkbox id="education" layout='horizontal' [for]="'education-Input'" [checkboxLabels]="[checkboxLabel]"
          [formGroup]="checkForm"></app-checkbox>
      </label>
    </div>
  </div>

  <form [formGroup]="form">
    <div class="form-grid work-history-form">
      <!-- Organization -->
      <div *ngIf="!checkForm.get('educationChecked')?.value" class="form-group">
        <app-text-input label="Work/school" [control]="fc['organizationName']" [for]="'org-input'"
          [errorMessages]="customErrorMessagesOrgandAddress" [maxLength]="FIELD_LIMITS['organizationName']['maxLength']"
          [ngClass] ="fc['organizationName'].errors ? 'showAsterisk' : 'hideAsterisk'">
        </app-text-input>
      </div>

      <div *ngIf="checkForm.get('educationChecked')?.value" class="form-group">
        <app-select-input class="story-drop" label="Dental School" [control]="fc['organizationName']"
          [for]="'org-input'" [options]="schoolsList" (selectionChanged)="onSchoolChange($event)"
          [isSearchable]="true"
          [ngClass] ="fc['organizationName'].errors ? 'showAsterisk' : 'hideAsterisk'"></app-select-input>
      </div>

      <!-- Other -->
      <div *ngIf="checkForm.get('educationChecked')?.value" class="form-group">
        <app-text-input label="Other school name" [control]="fc['other']" [for]="'address-input'"
        [ngClass] ="fc['other'].errors ? 'showAsterisk' : 'hideAsterisk'" [placeholder]="'Enter school name'"

          [errorMessages]="customErrorMessagesOrgandAddress" [maxLength]="FIELD_LIMITS['other']['maxLength']">
        </app-text-input>
      </div>
      <!-- Address -->
      <div class="form-group">
        <div class="marg-t-35 find-wdth">
          <label class= "location-field" for="location-name">Address</label>
          <input (focus) = "onFocus()" formControlName = "location" (ngModelChange) = "onLocationChange($event)" #locationInput type="text" id="location-name"
          [title]="(fc['location'].value?.length || 0) > 25 ? (fc['location'].value || '') : ''"
          name="location" aria-label="Work or school address" class="findform-input location-fieldbox">
          <div *ngIf = "showError" class="finddentist-validator">Required</div>
      </div>
      </div>


      <!-- City -->
      <div class="form-group">
        <app-text-input label="City" [control]="fc['city']" [for]="'city-input'"
          [errorMessages]="customErrorMessagesCity" [maxLength]="FIELD_LIMITS['city']['maxLength']">
        </app-text-input>
      </div>


      <!-- State -->
      <div class="form-group">
        <app-select-input class="story-drop" label="State" [control]="fc['state']" [options]="stateOptions"
          [for]="'state-select'" [isSearchable]="true">
        </app-select-input>
      </div>
      <!-- ZIP -->
      <div class="form-group">
        <app-text-input [label]="'ZIP'" [control]="fc['zip']" [for]="'zip-input'" [fieldType]="'This field'"
          [errorMessages]="customErrorMessagesZip" (keypress)="restrictNonNumeric($event)"
          [maxLength]="FIELD_LIMITS['zip']['maxLength']">
        </app-text-input>
      </div>



      <!-- Phone -->
      <div class="form-group">
        <app-text-input label="Phone" [control]="fc['phone']" [for]="'phone-input'" appPhoneMask
        [maxLength]="FIELD_LIMITS['phone']['maxLength']">
        </app-text-input>
      </div>

      <!-- Start Date -->
      <div *ngIf="form.get('hasGaps')?.value === 'false' || form.get('hasGaps')?.value === false">
        <div class="form-group">
          <app-date-input [maxDate]="today" label="Start date" [control]="fc['startDate']" [for]="'start-date'"
            [errorMessages]="customErrorMessageStartdate"
            [ngClass] ="fc['startDate'].errors ? 'showAsterisk' : 'hideAsterisk'">
          </app-date-input>
        </div>
      </div>


      <!-- End Date -->
      <div *ngIf="form.get('hasGaps')?.value === 'false' || form.get('hasGaps')?.value === false">
        <div class="form-group">
          <app-date-input [minDate]="fc['startDate'].value" [maxDate]="today" label="End date"
            [control]="fc['endDate']" [for]="'end-date'" [errorMessages]="customErrorMessageEnddate"
      [ngClass] ="fc['endDate'].errors ? 'showAsterisk' : 'hideAsterisk'">
          </app-date-input>
        </div>
      </div>

      <!-- Country -->
      <!-- <div class="form-group" *ngIf="checkForm.get('educationChecked')?.value" >
        <app-text-input [label]="'Country'" [control]="fc['country']" [for]="'country-input'" [fieldType]="'This field'"
          [errorMessages]="customErrorMessagesCountry"
          [maxLength]="FIELD_LIMITS['city']['maxLength']">
        </app-text-input>
      </div> -->
      <!-- Degree -->
      <div class="form-group" *ngIf="checkForm.get('educationChecked')?.value" >
        <app-select-input class="story-drop" [label]="'Degree'" [for] = "'degree-select'" [placeholder]="'None selected'"
        [options]="degreeOptions" [control]="fc['degree']" [isSearchable]="true" >
      </app-select-input>
    </div> 
      <!-- Education Type -->
      <div class="form-group" *ngIf="checkForm.get('educationChecked')?.value" >
        <app-select-input class="story-drop" [label]="'Education type'" [for] = "'educationType-select'" [placeholder]="'None selected'"
        [options]="educationTypeOptions" [control]="fc['educationType']" [isSearchable]="true" >
      </app-select-input>
    </div> 
      <div
        *ngIf="!checkForm.get('educationChecked')?.value&&!(form.get('hasGaps')?.value === 'true' || form.get('hasGaps')?.value === true)">
        <div class="form-group mr-top">
          <label class="checkbox-option">
            <app-checkbox id="work" layout='horizontal' [for]="'work-Input'" [checkboxLabels]="['Current employer']"
              [formGroup]="stillWorkingForm" (click)="onStillWorking($event)"></app-checkbox>
          </label>
        </div>
      </div>
    </div>

    <div class='explanation'>
      <div class='explanation-box1'>
        <div class="form-group full-width">
          <label class="formLabel">Gaps in work history</label>
          <app-radio [formGroup]="hasGapsGroup" [options]="gapOptions" [label]="''" [layout]="'horizontal'"
            (changed)="onGapsChange()">
          </app-radio>
        </div>
      </div>
      <div class='explanation-box2'>
        <div class="form-group" *ngIf="form.get('hasGaps')?.value === 'true' || form.get('hasGaps')?.value === true">
          <div class="form-group">
            <label>Explanation<span class="required" *ngIf="gapExplanation.errors"> *</span></label>
            <app-text-area id="note" [for]="'notes-Input'"
              class="remark-textarea remark-area-new dental-cred-text-field text-area-cred" [fieldType]="'This field'"
              [replaceDoubelQuotes]="true" [control]="gapExplanation" [label]="'Explanation'" [hideLabel]="true">
            </app-text-area>
          </div>

        </div>
      </div>
    </div>
    <div class="form-grid work-history-form">
      <!-- Start Date -->
      <div *ngIf="form.get('hasGaps')?.value === 'true' || form.get('hasGaps')?.value === true">
        <div class="form-group">
          <app-date-input label="Start date" [maxDate]="today" [control]="fc['startDate']" [for]="'start-date'"
            [errorMessages]="customErrorMessageStartdate"
            [ngClass] ="fc['startDate'].errors ? 'showAsterisk' : 'hideAsterisk'">
          </app-date-input>
        </div>
      </div>



      <!-- End Date -->
      <div *ngIf="form.get('hasGaps')?.value === 'true' || form.get('hasGaps')?.value === true">
        <div class="form-group">
          <app-date-input label="End date" [minDate]="fc['startDate'].value" [maxDate]="today"
          [ngClass] ="fc['endDate'].errors ? 'showAsterisk' : 'hideAsterisk'"
            [control]="fc['endDate']" [for]="'end-date'" [errorMessages]="customErrorMessageEnddate">
          </app-date-input>
        </div>
      </div>
    </div>
  </form>
</div>

<form [formGroup]="form" class="work-history-form">
  <div class="form-actions bottom-btngroup">
    <div>
      <button type="button" class="btn btn-primary next-btn" (click)="onCancel()">
        Cancel
      </button>
      <button type="button" class="btn btn-primary next-btn" (click)="onReset()" [disabled]="impersonatedUser">
        Reset
      </button>
    </div>
    <div>
      <button *ngIf="!isViewOnly" type="button" class="btn btn-primary next-btn mrg-left" (click)="onSave()"
        [disabled]="impersonatedUser">
        {{ isEditMode ? 'Update' : 'Save' }}
      </button>
    </div>
  </div>
</form>